"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79855],{

/***/ 579855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FlashSaleBlock": function() { return /* binding */ FlashSaleBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88837);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(505709);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(788813);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(185081);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(982226);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







const FlashSale = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(28644)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FlashSale), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const FlashSaleBlock = (param)=>{
    let { block , ssrProducts =[]  } = param;
    var ref;
    const { result: flashSaleData  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useSearch */ .Rx)(block && _objectSpreadProps(_objectSpread({}, block.cookedData.paramsObject), {
        blockId: block.id,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_4__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl
    }), {
        products: ssrProducts
    });
    const flsProducts = (flashSaleData === null || flashSaleData === void 0 ? void 0 : flashSaleData.products) && (flashSaleData === null || flashSaleData === void 0 ? void 0 : (ref = flashSaleData.products) === null || ref === void 0 ? void 0 : ref.length) > 0 ? flashSaleData === null || flashSaleData === void 0 ? void 0 : flashSaleData.products : ssrProducts;
    // get list of end timestamp second
    const endTimeStampSecList = [];
    (flsProducts || []).forEach((product)=>{
        const { flashSale  } = product;
        const endTimestampSec = flashSale === null || flashSale === void 0 ? void 0 : flashSale.endTimestampSec;
        if (!!endTimestampSec) endTimeStampSecList.push(endTimestampSec);
    });
    var ref1;
    return !!(flsProducts === null || flsProducts === void 0 ? void 0 : flsProducts.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
        marginBottom: "s24",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlashSale, {
            title: block.label,
            backgroundImage: block.backgroundImageUrl,
            endAt: (ref1 = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getMinimumTime */ .TV)(endTimeStampSecList)) !== null && ref1 !== void 0 ? ref1 : undefined,
            productsCarousel: {
                products: flsProducts,
                hideCtaButton: false,
                productsPerRow: 4,
                virtual: (0,helpers__WEBPACK_IMPORTED_MODULE_7__/* .isServerless */ .ep)()
            }
        })
    }) : null;
};


/***/ })

}]);